import { render, staticRenderFns } from "./SetRoles.vue?vue&type=template&id=312c765c&scoped=true"
import script from "./SetRoles.vue?vue&type=script&lang=js"
export * from "./SetRoles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312c765c",
  null
  
)

export default component.exports